import { createClient } from "@/lib/supabase/browser";
import { googleAuthEnabled } from "@/lib/flags";

export async function signInWithGoogle() {
  if (!googleAuthEnabled) {
    return { data: null, error: { message: 'Google auth disabled' } } as any;
  }
  // Always build from the canonical site URL (never window.location.origin) so
  // the OAuth round-trip returns to www regardless of which host the user
  // initiates from. An apex-initiated flow that sent an apex redirectTo was
  // dropped by Supabase (non-allowlisted) and never delivered a ?code to
  // /auth/callback. Mirrors the email signup fix in @/lib/auth/signup.
  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || 'https://www.indiestryvoice.com';
  const redirectTo = `${siteUrl}/auth/callback`;
  const supabase = createClient();
  return supabase.auth.signInWithOAuth({
    provider: "google",
    options: {
      redirectTo,
      queryParams: { prompt: "select_account" },
      skipBrowserRedirect: false,
    },
  });
} 